import { trans, useSoyuzExperiment } from '@spotahome/soyuz/client';

import Section from '@spotahome/ui-library/src/tenant/components/LandingSection/LandingSection';

import { getHowItWorksSteps } from '../../constants/howItWorks';

import HiwStepItem from './HiwStepItem';

import './HiwStepsDesktop.scss';

const HiwStepsDesktop = () => {
  const depositProtectionOnlyPlus = useSoyuzExperiment(
    'DepositProtectionOnlyPlus'
  );
  const isDepositProtectionVariant =
    depositProtectionOnlyPlus.get('behaviour') === 'variant';

  return (
    <Section containerClassName="hiw-steps-desktop">
      <h2 className="hiw-steps-desktop__title">
        {trans('how_it_works.steps.title')}
      </h2>
      {getHowItWorksSteps(isDepositProtectionVariant).map(
        (
          { titleKey, descriptionKey, bulletPoints, renderImage, cta },
          index
        ) => (
          <HiwStepItem
            stepNumber={index + 1}
            key={titleKey}
            titleKey={titleKey}
            descriptionKey={descriptionKey}
            bulletPoints={bulletPoints}
            renderImage={renderImage}
            cta={cta}
          />
        )
      )}
    </Section>
  );
};

export default HiwStepsDesktop;
